import styled, { css, CSSObject, SimpleInterpolation } from 'styled-components';
import {Breakpoints, Colors, Spacing} from './constants';
import {Link} from "react-router-dom";
import {Button, Field, TextInput} from "shared-react";
import {motion} from "framer-motion";

type CssArgsType = [CSSObject | TemplateStringsArray, SimpleInterpolation[]?];

export const media = {
  desktop: (...args: CssArgsType) => css`
    @media screen and (min-width: ${Breakpoints.Desktop}) {
      ${css(...args)};
    }
  `,
  mobile: (...args: CssArgsType) => css`
    @media screen and (max-width: ${Breakpoints.Desktop}) {
      ${css(...args)};
    }
  `
};

export const mobileOnly = () => media.desktop`{
  display: none;
}`;

export const desktopOnly = () => media.mobile`{
  display: none;
}`;

// animation config
export const FormCardVariants = {
  in: {
    y: 0,
    opacity: 1
  },
  out: {
    y: 20,
    opacity: 0
  }
}

export const FormCardTransition = {
  type: 'tween',
  duration: 0.3,
  ease: 'easeInOut'
}

export const FormCard = styled(motion.div)`
  width: 100%;
  max-width: 440px;
  margin: 70px auto 32px;
  box-shadow: 0 0 14px rgba(0, 0, 0, 0.05);
  border-radius: 10.6759px;
  background-color: ${Colors.White};
  padding: 32px 30px;
  align-items: center;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;

export const Form = styled.form `
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
`;

export const StyledField = styled(Field) `
  padding-top: 0.5rem;
  margin-bottom: ${Spacing.Space4};
  width: 100%;
`;

export const SubmitButton = styled(Button)`
  width: 100%;
`;

export const LinkContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto ${Spacing.Space7} auto;
`;

export const StyledLink = styled(Link)`
  cursor: pointer;
  color: ${Colors.Go};
  text-decoration: none;
`;

export const StyledA = styled.a `
  cursor: pointer;
  color: ${Colors.Go};
  text-decoration: none;
`;

export const SpanLink = styled.span `
  cursor: pointer;
  color: ${Colors.Go};
  text-decoration: none;
`;

export const FormCardHeader = styled.h1 `
  width: 100%;
  color: ${Colors.Black};
  font-size: 20px;
  line-height: 30px;
  font-weight: 500;
  margin-bottom: ${Spacing.Space4};
  text-align: left;
`;

export const Section = styled(FormCardHeader) `
  font-size: 18px;
`;

export const SectionColumn = styled(Section) `
  display: flex;
  flex-direction: column;
`;

export const Line = styled.div `
  border-bottom: 1px solid rgba(163, 163, 163, 0.1);
  flex-grow: 1;
  width: 440px;
  max-width: 100vw;
  height: 1px;
  padding: 0;
  margin-bottom: ${Spacing.Space4};
`;

export const ErrorContainer = styled.div<{border: string}> `
  width: 100%;
  margin: 0 0 1rem;
  background-color: ${Colors.White};
  border: 1px solid ${props => props.border || Colors.Warning75 };
  border-radius: 4px;
  color: ${props => props.color || Colors.Warning};
  font-size: 1.1rem;
  line-height: 1.6rem;
  text-align: center;
`;

export const ErrorCopy = styled.p `
  padding: 0.5rem 1rem;
`;

export const NameContainer = styled.div `
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const NameInput = styled(TextInput) `
  width: 100%
`;

export const CheckboxCopy = styled.span `
  line-height: 25px;
`;

export const CaptchaLegal = styled.p `
  text-align: center;
  font-size: 14px;
  margin-top: 32px;
`;

export const CaptchaContainer = styled.div`
  max-height: 0px;
  overflow: hidden;
`;
